// Initial state
function initialState() {
	return {
		jobID: '',
		accountDetails: {},
		accountID: '',
		reference: '',
		referenceID: '',
		inputBy: '',
		trackingID: '',
		zone: 1,
		zoneStatic: '',
		zoneTimestamp: '',
		zoneHistory: '',
		startingJobCategory: 'A',
		jobCategory: 'A',
		eligibleDiscountCategories: ['Frame', 'Lens', 'Glazing', 'Addon']
	}
}

const state = initialState()

// Getters
const getters = {
	jobID: (state) => {
		return state.jobID
	},
	account: (state) => {
		return state.accountDetails.Organisation
	},
	discount: (state) => {
		return typeof state.accountDetails.Discount !== 'undefined' ? state.accountDetails.Discount : 0
	},
	lineItemDiscounts: (state) => {
		return state.eligibleDiscountCategories
	},
	reference: (state) => {
		return state.reference
	},
	referenceID: (state) => {
		return state.referenceID
	},
	inputBy: (state) => {
		return state.inputBy
	},
	trackingID: (state) => {
		return state.trackingID
	},
	zone: (state) => {
		return state.zone
	},
	zoneStatic: (state) => {
		return state.zoneStatic
	},
	zoneTimestamp: (state) => {
		return state.zoneTimestamp
	},
	zoneHistory: (state) => {
		return state.zoneHistory
	},
	startingJobCategory: (state) => {
		return state.startingJobCategory
	},
	jobCategory: (state) => {
		return state.jobCategory
	}
}

// Actions
const actions = {
	resetState ({ state, commit }) {
		commit('reset')
	},
	addJobID ({ state, commit }, value) {
		commit('setJobID', value)
	},
	removeJobID ({ state, commit }) {
		commit('setJobID', '')
	},
	addAccount ({ state, commit }, value) {
		commit('setAccount', value)
	},
	removeAccount ({ state, commit }) {
		commit('unsetAccount')
	},
	addAccountID ({ state, commit }, value) {
		commit('setAccountID', value)
	},
	addReference ({ state, commit }, value) {
		commit('setReference', value)
	},
	addReferenceID ({ state, commit }, value) {
		commit('setReferenceID', value)
	},
	addInputBy ({ state, commit }, value) {
		commit('setInputBy', value)
	},
	addTrackingID ({ state, commit }, value) {
		commit('setTrackingID', value)
	},
	removeTrackingID ({ state, commit }) {
		commit('setTrackingID', '')
	},
	addZone ({ state, commit }, value) {
		commit('setZone', value)
	},
	addZoneStatic ({ state, commit }, value) {
		commit('setZoneStatic', value)
	},
	addZoneTimestamp ({ state, commit }, value) {
		commit('setZoneTimestamp', value)
	},
	removeZoneTimestamp ({ state, commit }) {
		commit('setZoneTimestamp', '')
	},
	addZoneHistory ({ state, commit }, value) {
		commit('setZoneHistory', value)
	},
	removeZoneHistory ({ state, commit}) {
		commit('setZoneHistory', '')
	},
	addStartingJobCategory ({ state, commit }, value) {
		commit('setStartingJobCategory', value)
	},
	addJobCategory ({ state, commit }, value) {
		commit('setJobCategory', value)
	}
}

// Mutations
const mutations = {
	reset (state) {
		// acquire initial state
		const s = initialState()
		Object.keys(s).forEach(key => {
			state[key] = s[key]
		})
	},
	setJobID (state, value) {
		state.jobID = value
	},
	setAccount (state, value) {
		state.accountDetails = value
	},
	unsetAccount (state, value) {
		state.accountDetails = {}
	},
	setAccountID (state, value) {
		state.accountID = value
	},
	setReference (state, value) {
		state.reference = value
	},
	setReferenceID (state, value) {
		state.referenceID = value
	},
	setInputBy (state, value) {
		state.inputBy = value
	},
	setTrackingID (state, value) {
		state.trackingID = value
	},
	setZone (state, value) {
		state.zone = value
	},
	setZoneStatic (state, value) {
		state.zoneStatic = value
	},
	setZoneTimestamp (state, value) {
		state.zoneTimestamp = value
	},
	setZoneHistory (state, value) {
		state.zoneHistory = value
	},
	setStartingJobCategory (state, value) {
		state.startingJobCategory = value
	},
	setJobCategory (state, value) {
		state.jobCategory = value
	}
}

export default {
	namespaced: false,
	state,
	getters,
	actions,
	mutations
}
